// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-file-upload {
  color: var(--gc-text-color-inverse);
  background: var(--gc-color-primary);
  border: 1px solid var(--gc-color-primary);
  padding: 0.45rem 1.2rem;
  transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
  border-radius: 4px;
  cursor: pointer;
}
.custom-file-upload.p-button-text {
  background: transparent;
  color: var(--gc-color-primary);
  border-color: transparent;
}
.custom-file-upload.p-button-text:hover {
  background: rgba(0, 123, 255, 0.04);
  color: var(--gc-color-primary);
  border-color: transparent;
}
.custom-file-upload:hover {
  background: var(--gc-color-primary-shade);
  color: var(--gc-text-color-inverse);
  border-color: var(--gc-color-primary-shade);
}
.custom-file-upload input[type=file] {
  display: none;
}

.info {
  font-size: 0.75rem;
  color: var(--gc-color-dark-tint);
}

.preview.image {
  width: 10rem;
  height: 10rem;
}
.preview.image.mask-circle {
  border: 1px solid var(--gc-color-dark);
  border-radius: 50%;
}
.preview.image.mask-square {
  border: 1px solid var(--gc-color-dark);
}
.preview.image img {
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

canvas {
  width: 90vw;
  height: 50.625vw;
  max-width: 750px;
  max-height: 421.875px;
  background: #333;
}

.controls {
  margin: 2em;
}

.info-box {
  width: 100%;
  border: 1px solid lightgrey;
  display: flex;
  flex-direction: column;
  padding: 7px 14px;
}
.info-box span {
  display: flex;
  flex-direction: column;
  text-align: center;
  color: grey;
}

.hidden {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-file-upload/file-upload.component.sass"],"names":[],"mappings":"AAEA;EACI,mCAAA;EACA,mCAJY;EAKZ,yCAAA;EACA,uBAAA;EACA,wEAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAEI;EACI,uBAAA;EACA,8BAZQ;EAaR,yBAAA;AAAR;AACQ;EACI,mCAAA;EACA,8BAhBI;EAiBJ,yBAAA;AACZ;AAAI;EACI,yCAAA;EACA,mCAAA;EACA,2CAAA;AAER;AADI;EACI,aAAA;AAGR;;AADA;EACI,kBAAA;EACA,gCAAA;AAIJ;;AAAI;EAMI,YAAA;EACA,aAAA;AAFR;AAJQ;EACI,sCAAA;EACA,kBAAA;AAMZ;AALQ;EACI,sCAAA;AAOZ;AAJQ;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AAMZ;;AAFA;EACI,WAAA;EACA,gBAAA;EACA,gBAJY;EAKZ,qBAAA;EACA,gBAAA;AAKJ;;AAHA;EACI,WAAA;AAMJ;;AAJA;EACI,WAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAOJ;AANI;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AAQR;;AAPA;EACI,wBAAA;AAUJ","sourcesContent":["$primary-color: var(--gc-color-primary)\n\n.custom-file-upload\n    color: var(--gc-text-color-inverse)\n    background: $primary-color\n    border: 1px solid $primary-color\n    padding: 0.45rem 1.2rem\n    transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s\n    border-radius: 4px\n    cursor: pointer\n    &.p-button-text\n        background: transparent\n        color: $primary-color\n        border-color: transparent\n        &:hover\n            background: rgba(0, 123, 255, 0.04)\n            color: $primary-color\n            border-color: transparent\n    &:hover\n        background: var(--gc-color-primary-shade)\n        color: var(--gc-text-color-inverse)\n        border-color: var(--gc-color-primary-shade)\n    input[type=\"file\"]\n        display: none\n\n.info\n    font-size: 0.75rem\n    color: var(--gc-color-dark-tint)\n\n.preview\n    // margin-bottom: 5rem\n    &.image\n        &.mask-circle\n            border: 1px solid var(--gc-color-dark)\n            border-radius: 50%\n        &.mask-square\n            border: 1px solid var(--gc-color-dark)\n        width: 10rem\n        height: 10rem\n        img\n            width: 100%\n            height: 100%\n            border-radius: inherit\n\n$canvasSize: 90vw\n$maxCanvasSize: 750px\ncanvas\n    width: calc( $canvasSize )\n    height: calc( $canvasSize / 16 * 9 )\n    max-width: $maxCanvasSize\n    max-height: calc( $maxCanvasSize / 16 * 9 )\n    background: #333\n\n.controls\n    margin: 2em\n\n.info-box\n    width: 100%\n    border: 1px solid lightgrey\n    display: flex\n    flex-direction: column\n    padding: 7px 14px\n    span\n        display: flex\n        flex-direction: column\n        text-align: center\n        color: grey\n.hidden\n    display: none !important"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
